export const otherTableOption = function (areaShow, menuShow) {
  if (areaShow) {
    return {
      stripe: true,
      page: true,
      maxHeight: "100%",
      align: "center",
      header: false,
      selection: true,
      index: true,
      emptyText: "暂无数据",
      column: [
        {
          prop: "check",
          hide: true,
          search: true,
          searchSlot: true,
        },
        {
          label: "设备名称",
          prop: "deviceName",
          align: "center",
          search: true,
          overHidden: true
        },
        {
          label: "描述",
          prop: "deviceDescription",
          align: "center",
          search: false,
          overHidden: true
        }
      ]
    };
  } else {
    return {
      stripe: true,
      page: true,
      maxHeight: "100%",
      align: "center",
      header: false,
      selection: true,
      index: true,
      emptyText: "暂无数据",
      column: [
        {
          prop: "check",
          hide: true,
          search: true,
          searchSlot: true,
        },
        {
          label: "设备名称",
          prop: "deviceName",
          align: "center",
          search: true,
          overHidden: true
        },
        {
          label: "描述",
          prop: "deviceDescription",
          align: "center",
          search: false,
          overHidden: true
        }
      ]
    };
  }
};
